import React from "react";
import { connect } from "react-redux";
import {
  eventParticipants,
  registryConfiguration,
} from "../../../../../data-store/actions/registry-actions";
import {
  completeNull,
  modalidadCateogoriaNameByCode,
} from "../../../../../services/utils";
import IncomeTableCont from "./IncomeTableCont";
import DynamicInputs from "../../../../DynamicInput/DynamicInputs";
import DownloadButtomAllData from "../DownloadData/DownloadButtomAllDataNew";
import InputRenderOnChange from "../../../../Fields/InputRenderOnChange";
import FormRender from "../../../../Fields/FormRender";
import { Button, Grid, makeStyles, Typography } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import InputBase from "@material-ui/core/InputBase";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import NoveltyInfoButton from "../../../Changelog/NoveltyInfoButton";
import {
  construirColumnasDinamicas,
  opcionesModalidad,
  opcionesCategoria,
  opcionesRama,
  opcionesUsuario,
  OPCIONES_ESTATUS,
  OPCIONES_WARNINGS,
} from "./incomeTableLogic";

// Mismo estilo compacto (poco espaciado vertical) para encabezado y filas.
export const celdaCompacta = { padding: "4px 8px" };

function construirColumnasEstaticas(
  apellidosSeparadosSet,
  eventSubEventsRegistry,
  registryAutorizedUsers
) {
  const columnas = [
    { id: "numero", label: "Número" },
    // Ajuste temporal (2026-10): una sola columna para las dos alertas
    // (edad y dorsal), pero el filtro permite escoger cuál ver. Más
    // adelante se revisa de nuevo este punto.
    {
      id: "warnings",
      label: "Alertas",
      tipo: "select",
      opciones: OPCIONES_WARNINGS,
    },
    { id: "nombres", label: "Nombre (solo nombre)" },
  ];
  if (apellidosSeparadosSet) {
    columnas.push({ id: "apellidoPaterno", label: "Apellido Paterno" });
    columnas.push({ id: "apellidoMaterno", label: "Apellido Materno" });
  } else {
    columnas.push({ id: "apellidos", label: "Apellido" });
  }
  columnas.push(
    { id: "correo", label: "Correo" },
    { id: "telefono", label: "Teléfono" },
    {
      id: "modalidad",
      label: "Modalidad",
      tipo: "select",
      opciones: opcionesModalidad(eventSubEventsRegistry),
    },
    {
      id: "rama",
      label: "Rama",
      tipo: "select",
      opciones: opcionesRama(eventSubEventsRegistry),
    },
    {
      id: "categoria",
      label: "Categoria",
      tipo: "select",
      opciones: opcionesCategoria(eventSubEventsRegistry),
    },
    {
      id: "usuario",
      label: "Usuario",
      tipo: "select",
      opciones: opcionesUsuario(registryAutorizedUsers),
    },
    { id: "precioCobrado", label: "Precio cobrado" },
    {
      id: "fechaRegistro",
      label: "Fecha Registro",
      tipo: "rango-fecha",
      leyenda:
        "Es la fecha de registro, no la de pago — en inscripciones por OXXO el pago puede confirmarse días después.",
    }
  );
  return columnas;
}

class IncomeView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: 1,
      quantity: 100,
      // Por defecto, el más reciente arriba — sin esto el orden era el que
      // Firebase entrega (claves push, de más antiguo a más nuevo).
      ordenarPor: "fechaRegistro",
      direccionOrden: "desc",
      filtros: {},
    };
  }

  ordenarPorColumna = (columnId) => {
    if (this.state.ordenarPor === columnId) {
      this.setState({
        direccionOrden: this.state.direccionOrden === "asc" ? "desc" : "asc",
      });
    } else {
      this.setState({ ordenarPor: columnId, direccionOrden: "asc" });
    }
  };

  actualizarFiltroColumna = (columnId, texto) => {
    this.setState({
      filtros: { ...this.state.filtros, [columnId]: texto },
    });
  };

  // Filtros de rango (ej. fecha de registro): el input datetime-local
  // entrega un string "YYYY-MM-DDTHH:mm" en hora local, igual que como se
  // interpreta/muestra serverTime en el resto de la tabla — se guarda el
  // epoch (lo que de verdad usa coincideFiltros para comparar) junto con el
  // texto crudo (solo para que el input quede controlado y muestre lo que
  // el usuario escribió).
  actualizarFiltroRango = (columnId, campo, valorTexto) => {
    const timestamp = valorTexto ? new Date(valorTexto).getTime() : null;
    this.setState((prevState) => ({
      filtros: {
        ...prevState.filtros,
        [columnId]: {
          ...(prevState.filtros[columnId] || {}),
          [campo]: timestamp,
          [campo + "Texto"]: valorTexto,
        },
      },
    }));
  };

  camposAdicionalesModalidad = () => {
    var camposAdicionalesModalidad = [];
    var camposAdicionalesModalidadHTML = [];

    var formulario = this.props.registryConfiguration.formulario;
    for (var i in formulario) {
      if (formulario[i].tipoCampo != "titulo") {
        camposAdicionalesModalidad.push(formulario[i]);
        camposAdicionalesModalidadHTML.push(
          <TableCell
            key={formulario[i].campo}
            data-field={formulario[i].etiqueta}
          >
            {formulario[i].etiqueta}
          </TableCell>
        );
      }
    }
    var modalidadesBuscar = this.props.eventSubEventsRegistry;

    var arrayCampoModalidad = [];

    for (var i in modalidadesBuscar) {
      var modalidadCampos =
        modalidadesBuscar[i].configModalidad.camposAdicionalesModalidad;
      if (modalidadCampos != undefined) {
        for (var e in modalidadCampos) {
          var campos = modalidadCampos[e];
          for (var f in campos) {
            if (campos[f].tipoCampo != "titulo") {
              if (!arrayCampoModalidad.includes(campos[f].iDCampo)) {
                arrayCampoModalidad.push(campos[f].iDCampo);
                camposAdicionalesModalidad.push(campos[f]);
                camposAdicionalesModalidadHTML.push(
                  <TableCell
                    key={i + e + f + "CA"}
                    data-field={campos[f].etiqueta}
                  >
                    {campos[f].etiqueta}
                  </TableCell>
                );
                console.log("Campos " + campos[f].campo);
              }
            }
          }
        }
      }
    }

    return {
      camposAdicionalesModalidad: camposAdicionalesModalidad,
      camposAdicionalesModalidadHTML: camposAdicionalesModalidadHTML,
    };
  };

  productosAdicionalesModalidadTitulo = () => {
    var productosAdicionalesModalidadTitulo = [];
    var productosAdicionalesModalidadTituloHTML = [];

    var modalidadesBuscar = this.props.eventSubEventsRegistry;
    var arrayCodigoProducto = [];

    for (var i in modalidadesBuscar) {
      var modalidadProductos =
        modalidadesBuscar[i].configModalidad.productosAdicionales !== undefined
          ? modalidadesBuscar[i].configModalidad.productosAdicionales
          : {};

      if (modalidadProductos) {
        modalidadProductos["codeDiscount"] = {
          codigoProducto: "códigoDescuento",
          descripcionProducto: "Código de descuento",
          formularioProducto: [
            {
              anchoCampo: "s12 m6 l6",
              campo: 0,
              etiqueta: "code",
              iDCampo: "code",
              longitud: 100,
              observacion: "",
              regex: "",
              regexMessage: "",
              tipoCampo: "text",
              validacion: "Requerido",
              valor: "",
              hideMasterOrganizador: true,
              hideMasterCliente: true,
              hideInPublic: true,
              hideInscriptor: true,
            },
          ],
          maxCantidad: 1,
          nombreProducto: "Código de descuento",
          precioProducto: 100,
        };

        console.log("Productos", modalidadProductos);
      }

      if (modalidadProductos !== undefined) {
        for (var e in modalidadProductos) {
          if (
            !arrayCodigoProducto.includes(modalidadProductos[e].codigoProducto)
          ) {
            arrayCodigoProducto.push(modalidadProductos[e].codigoProducto);
            productosAdicionalesModalidadTitulo.push(modalidadProductos[e]);

            productosAdicionalesModalidadTituloHTML.push(
              <TableCell
                key={i + e + "cantidad"}
                data-field={`${modalidadProductos[e].nombreProducto}-Cantidad`}
              >
                {modalidadProductos[e].nombreProducto} - Cantidad
              </TableCell>
            );
            productosAdicionalesModalidadTituloHTML.push(
              <TableCell
                key={i + e + "precio"}
                data-field={`${modalidadProductos[e].nombreProducto}-Precio`}
              >
                {modalidadProductos[e].nombreProducto} - Precio
              </TableCell>
            );
            productosAdicionalesModalidadTituloHTML.push(
              <TableCell
                key={i + e + "total"}
                data-field={`${modalidadProductos[e].nombreProducto}-Total`}
              >
                {modalidadProductos[e].nombreProducto} - Total
              </TableCell>
            );
            var formularioProducto = modalidadProductos[e].formularioProducto;
            if (formularioProducto != undefined) {
              for (var f in formularioProducto) {
                productosAdicionalesModalidadTituloHTML.push(
                  <TableCell
                    key={i + e + f + "input"}
                    data-field={formularioProducto[f].etiqueta}
                  >
                    {formularioProducto[f].etiqueta}
                  </TableCell>
                );
              }
            }

            console.log(JSON.stringify(modalidadProductos[e]));
          }
        }
      }
    }

    return {
      productosAdicionalesModalidadTitulo: productosAdicionalesModalidadTitulo,
      productosAdicionalesModalidadTituloHTML: productosAdicionalesModalidadTituloHTML,
    };
  };

  render() {
    const sticky = {
      position: "sticky",
      left: 0,
      backgroundColor: "#ffffff",
      borderRight: "2px solid red",
      zIndex: 1000,
    };
    const sticky1 = {
      // position: "sticky",
      // top: 0,
      // backgroundColor: "#ffffff",
      // borderRight: "2px solid red",
      // zIndex: 1000,
    };

    const opcionesFiltro = [
      { value: 1, label: "Inscripciones completas" },
      { value: 2, label: "Registros incompletos o borrados" },
      { value: 3, label: "Ver todos los registros" },
    ];

    var notificacionNovedad = (
      <NoveltyInfoButton
        anchors={["tab-ingresos"]}
        onSeen={this.props.onNoveltySeen}
      />
    );
    var tituloTablaIngresos;
    var perfilUsuarioEvento = this.props.registryAutorizedUsers[
      this.props.userID
    ].perfil;
    if (
      perfilUsuarioEvento.localeCompare("MasterCliente") == 0 ||
      perfilUsuarioEvento.localeCompare("MasterOrganizador") == 0 ||
      perfilUsuarioEvento.localeCompare("master") == 0
    ) {
      tituloTablaIngresos = (
        <div>
          {notificacionNovedad}
          <Typography variant={"h3"} align="left">
            Listado de inscritos
          </Typography>
          <Typography variant={"subtitle1"} align="left">
            Inlcuye ingresos cobrados en linea y en puntos de venta. Reporte
            disponible solo para usuarios Master
          </Typography>
        </div>
      );
    } else {
      tituloTablaIngresos = (
        <div>
          {notificacionNovedad}
          <Typography variant={"h3"} align="left">
            Listado de inscritos
          </Typography>

          <Typography variant={"subtitle1"} align="left">
            Nota: Reporte de ingresos registrados con tu nombre de usuario
          </Typography>
          <DownloadButtomAllData
            eventParticipants={this.props.eventParticipants}
            reportType={3}
            eventDetail={this.props.eventDetail}
            registryAutorizedUsers={this.props.registryAutorizedUsers}
            userID={this.props.userID}
            registryConfiguration={this.props.registryConfiguration}
            eventSubEventsRegistry={this.props.eventSubEventsRegistry}
          />
        </div>
      );
    }

    var camposAdicionales = this.camposAdicionalesModalidad();

    var productosAdicionales = this.productosAdicionalesModalidadTitulo();

    var apellidosSeparadosSet = this.props.registryConfiguration.configuracion
      .separarApellidos;

    var todasLasColumnas = [
      ...construirColumnasEstaticas(
        apellidosSeparadosSet,
        this.props.eventSubEventsRegistry,
        this.props.registryAutorizedUsers
      ),
      ...construirColumnasDinamicas(
        camposAdicionales.camposAdicionalesModalidad,
        productosAdicionales.productosAdicionalesModalidadTitulo
      ),
      { id: "estatus", label: "Estatus", tipo: "select", opciones: OPCIONES_ESTATUS },
    ];

    // TODO: filtro por modalidad, rama, categoria.
    // TODO agregar vista de cambio a peso.

    const width = "auto";
    // 3000 +
    // camposAdicionales.camposAdicionalesModalidadHTML.length * 80 +
    // productosAdicionales.productosAdicionalesModalidadTituloHTML.length * 80;
    return (
      <Grid
        container
        direction="row"
        justifyContent="space-evenly"
        alignItems="flex-start"
      >
        <Grid item xs={12} sm={12}>
          {tituloTablaIngresos}
        </Grid>
        <Grid item xs={12} sm={12} style={{ marginBottom: 10 }}>
          {opcionesFiltro.map((opcion) => (
            <Button
              key={opcion.value}
              variant={this.state.filter === opcion.value ? "contained" : "outlined"}
              color="primary"
              onClick={() => this.setState({ filter: opcion.value })}
              style={{ marginRight: 10, marginBottom: 10 }}
            >
              {opcion.label}
            </Button>
          ))}
          <Button
            variant="contained"
            color="secondary"
            onClick={() => this.setState({ quantity: Infinity })}
            style={{ marginBottom: 10 }}
          >
            Mostrar toda la lista de inscritos
          </Button>
        </Grid>
        <Grid item xs={12} sm={12}>
          {/* Compacta TODAS las celdas (encabezado y cada fila armada en
              IncomeRow.jsx) sin tener que agregar estilos en cada una —
              IncomeRow.jsx genera muchas celdas dentro de loops, así que un
              único override por CSS es más confiable que tocar cada una. */}
          <style>{`
            .income-table-compacta .MuiTableCell-root {
              padding: 2px 8px !important;
            }
          `}</style>
          <TableContainer
            className="income-table-compacta"
            style={{ overflowX: "initial" }}
          >
            <Table
              size="small"
              style={{ width: width + "px" }}
              aria-label="a dense table"
              stickyHeade
            >
              <TableHead stickyHeader={true}>
                <TableRow>
                  {todasLasColumnas.map((col) => (
                    <TableCell
                      key={col.id}
                      align="center"
                      style={
                        col.id === "numero"
                          ? { ...sticky, ...celdaCompacta }
                          : celdaCompacta
                      }
                    >
                      <TableSortLabel
                        active={this.state.ordenarPor === col.id}
                        direction={
                          this.state.ordenarPor === col.id
                            ? this.state.direccionOrden
                            : "asc"
                        }
                        onClick={() => this.ordenarPorColumna(col.id)}
                      >
                        {col.label}
                      </TableSortLabel>
                    </TableCell>
                  ))}
                </TableRow>
                <TableRow>
                  {todasLasColumnas.map((col) => (
                    <TableCell
                      key={col.id + "-filtro"}
                      style={
                        col.id === "numero"
                          ? { ...sticky, ...celdaCompacta, top: 37 }
                          : celdaCompacta
                      }
                    >
                      {col.tipo === "select" ? (
                        <Select
                          displayEmpty
                          value={this.state.filtros[col.id] || ""}
                          onChange={(e) =>
                            this.actualizarFiltroColumna(col.id, e.target.value)
                          }
                          style={{ fontSize: 12, width: "100%" }}
                        >
                          <MenuItem value="">
                            <em>(Todos)</em>
                          </MenuItem>
                          {col.opciones.map((opcion) => (
                            <MenuItem key={opcion.value} value={opcion.value}>
                              {opcion.label}
                            </MenuItem>
                          ))}
                        </Select>
                      ) : col.tipo === "rango-fecha" ? (
                        <div style={{ minWidth: 170 }}>
                          <div style={{ display: "flex", gap: 4 }}>
                            <TextField
                              type="datetime-local"
                              title="Desde"
                              inputProps={{ style: { fontSize: 11, padding: "4px 2px" } }}
                              value={
                                (this.state.filtros[col.id] && this.state.filtros[col.id].desdeTexto) || ""
                              }
                              onChange={(e) =>
                                this.actualizarFiltroRango(col.id, "desde", e.target.value)
                              }
                              style={{ width: "50%" }}
                            />
                            <TextField
                              type="datetime-local"
                              title="Hasta"
                              inputProps={{ style: { fontSize: 11, padding: "4px 2px" } }}
                              value={
                                (this.state.filtros[col.id] && this.state.filtros[col.id].hastaTexto) || ""
                              }
                              onChange={(e) =>
                                this.actualizarFiltroRango(col.id, "hasta", e.target.value)
                              }
                              style={{ width: "50%" }}
                            />
                          </div>
                          {col.leyenda && (
                            <Typography
                              variant="caption"
                              color="textSecondary"
                              style={{ display: "block", fontSize: 9, lineHeight: 1.3, marginTop: 2 }}
                            >
                              {col.leyenda}
                            </Typography>
                          )}
                        </div>
                      ) : (
                        <InputBase
                          placeholder="Filtrar..."
                          value={this.state.filtros[col.id] || ""}
                          onChange={(e) =>
                            this.actualizarFiltroColumna(col.id, e.target.value)
                          }
                          style={{ fontSize: 12, width: "100%" }}
                        />
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <IncomeTableCont
                camposAdicionales={camposAdicionales}
                productosAdicionales={productosAdicionales}
                filter={this.state.filter}
                quantity={this.state.quantity}
                ordenarPor={this.state.ordenarPor}
                direccionOrden={this.state.direccionOrden}
                filtrosColumnas={this.state.filtros}
              />
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {};
};

const mapStateToProps = (state) => {
  return {
    eventParticipants: state.registry.eventParticipants,
    eventSubEventsRegistry: state.events.eventSubEventsRegistry,
    registryConfiguration: state.registry.registryConfiguration,
    registryAutorizedUsers: state.registry.registryAutorizedUsers,
    userID: state.atlete.userID,
    eventDetail: state.events.eventDetail,
    atleteAccount: state.atlete.atleteAccount,
  };
};

const Income = connect(mapStateToProps, mapDispatchToProps)(IncomeView);
export default Income;
